import { createFileRoute } from '@tanstack/react-router';
import { DocumentPage, validateViewDocSearch } from '@/components/sales/document-page';

export const Route = createFileRoute('/sales/invoices/$documentId')({
  component: View,
  validateSearch: validateViewDocSearch,
});

function View() {
  const { documentId } = Route.useParams();
  const { send, apply } = Route.useSearch();
  return (
    <DocumentPage
      kind="invoice"
      id={documentId}
      openSend={send === '1'}
      openApply={apply === '1'}
    />
  );
}
